module.exports = {"320981100":"溱东镇","320981101":"时堰镇","320981106":"五烈镇","320981107":"梁垛镇","320981108":"安丰镇","320981109":"南沈灶镇","320981110":"富安镇","320981112":"唐洋镇","320981113":"新街镇","320981114":"许河镇","320981115":"三仓镇","320981118":"头灶镇","320981121":"弶港镇","320981122":"东台镇","320981400":"江苏省新曹农场","320981401":"江苏省农垦弶港农场","320981409":"开发区","320981410":"沿海经济区","320981411":"城东新区","320981412":"西溪景区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320981.json
// module id = 913
// module chunks = 0